import Components from './components/index.js';
import App from './app.js';

const app = new App();

app.bootstrap();
Components.install();

export default app;
